var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/logo_red.png"),"alt":""}}),_c('h1',[_vm._v(_vm._s(_vm.$t('欢迎使用本系统')))])])}
var staticRenderFns = []

export { render, staticRenderFns }